module.exports = __webpack_public_path__ + "media/tags/peta-34c46ca4.png";